import {api} from "../http/apiClient";

const ApiPlannings = () => {
  const createPlanning = (data) => {
    return api.post(`/plans/`, data);
  }
  const countActivePlannings = (cnpj) => {
    return api.get(`/plans/count-active/`, {
      params: {
        cnpj,
      },
    });
  }
  const getPlanning = (idPlanning) => {
    return api.get(`/plans/${idPlanning}/`);
  }
  const currentStatus = (params) => {
    return api.get(`/plans/current-status/`, {
      params,
    });
  }
  const plannings = (params) => {
    return api.get(`/plans/`, {
      params: params,
    });
  }
  const planningsList = (params) => {
    return api.get(`/plans/list/`, {
      params: params,
    });
  }
  const consultingList = (params) => {
    return api.get(`/plans/consulting/`, {
      params: params,
    });
  }
  const usersSharedList = (params) => {
    return api.get(`/plans/invite/users-shared/`, {
      params: params,
    });
  }
  const companiesSharedList = (params) => {
    return api.get(`/plans/invite/companies/`, {
      params: params,
    });
  }
  const planningsShared = (params) => {
    return api.get(`/plans/list-shared/`, {
      params: params,
    });
  }
  const listPostCredit = (params) => {
    return api.get(`/post-credit/`, {
      params: params,
    });
  }
  const listPostCreditClients = (document) => {
    return api.get(`/post-credit/clients/`, {
      params: {
        document,
      },
    });
  }
  const listPostCreditJourney = (params = {}) => {
    return api.get(`/post-credit/overview/`, {
      params,
    });
  }
  const getPostCreditMonth = (monthId) => {
    return api.get(`/post-credit/months/${monthId}/`);
  }
  const updatePostCreditMonthData = (monthId, data) => {
    return api.post(`/post-credit/months/${monthId}/update_data/`, data);
  }
  const closePostCreditMonth = (monthId, data) => {
    return api.post(`/post-credit/months/${monthId}/close/`, data);
  }
  const deletePlanning = (id) => {
    return api.delete(`/plans/${id}/`);
  }
  const updatePlanning = (data, id) => {
    return api.patch(`/plans/${id}/`, data);
  }
  const monitorPlanning = (id) => {
    return api.post(`/post-credit/from-plan/${id}/`);
  }
  const canMonitored = (cnpj) => {
    return api.get(`/plans/can-monitored/`, {
      params: {
        cnpj,
      },
    });
  }
  const archivePlanning = (id) => {
    return api.post(`/post-credit/${id}/archive/`);
  }
  const restorePlanning = (id) => {
    return api.post(`/post-credit/${id}/restore/`);
  }
  const createExistingDebt = (data) => {
    return api.post(`/plans/existing-debt/`, data);
  }
  const updateOutput = (id, data, type) => {
    return api.patch(`/plans/${type}/${id}/`, data);
  }
  const deleteOutput = (id, type) => {
    return api.delete(`/plans/${type}/${id}/`);
  }
  const createCreditSimulation = (data) => {
    return api.post(`/plans/credit-simulations/`, data);
  }
  const duplicatePlanning = (id, cnpj) => {
    return api.get(`/plans/duplicate/${id}/`, {
      params: {
        cnpj,
      },
    });
  }
  const simulateFampe = (data) => {
    return api.post(`/plans/fampe/simulate/`, data);
  }
  const getScore = (cnpj) => {
    return api.get(`/user-score/`, {
      params: {
        cnpj,
      },
    });
  }
  const updateBalanceAdjustments = (data) => {
    return api.post(`/plans/balance-adjustments/`, data);
  }
  const getOpinionsList = (idPlanning) => {
    return api.get(`/plans/${idPlanning}/opinions/`);
  }
  const getPlanningNotes = async (idPlanning) => {
    return await api.get(`/app/plan/${idPlanning}/notes/`);
  }
  const getPlanningReport = async (idPlanning) => {
    return await api.get(`/app/plan/${idPlanning}/report/`);
  }
  const createOpinion = (idPlanning, data) => {
    return api.post(`/plans/${idPlanning}/opinions/`, data);
  }
  const updateOpinion = (idPlanning, idOpinion, data) => {
    return api.patch(`/plans/${idPlanning}/opinions/${idOpinion}/`, data);
  }
  const markDownloadDashboard = (idPlanning) => {
    return api.patch(`/plans/${idPlanning}/mark-downloaded/`, null, {
      skipAuthError: true,
    });
  }
  const getRecommendations = (plan_id) => {
    return api.get(`/plans/recomendations/`, {
      params: {
        plan_id,
      },
    });
  }
  const updateRecommendations = (plan_id, data) => {
    return api.patch(`plans/recomendations/${plan_id}/mark-read/`, data);
  }
  const hasConsultingAccess = () => {
    return api.get(`/user-role/consultor/`);
  }

  return {
    countActivePlannings,
    createPlanning,
    getPlanning,
    currentStatus,
    plannings,
    planningsShared,
    listPostCredit,
    listPostCreditClients,
    listPostCreditJourney,
    getPostCreditMonth,
    updatePostCreditMonthData,
    closePostCreditMonth,
    deleteOutput,
    updateOutput,
    monitorPlanning,
    canMonitored,
    archivePlanning,
    restorePlanning,
    deletePlanning,
    updatePlanning,
    duplicatePlanning,
    simulateFampe,
    getScore,
    createExistingDebt,
    createCreditSimulation,
    updateBalanceAdjustments,
    getOpinionsList,
    getPlanningNotes,
    getPlanningReport,
    createOpinion,
    updateOpinion,
    markDownloadDashboard,
    getRecommendations,
    updateRecommendations,
    planningsList,
    usersSharedList,
    hasConsultingAccess,
    consultingList,
    companiesSharedList,
  }
}

export default ApiPlannings;
